import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import additionalFeesTranslation from 'lumen/utils/short-term-rental-utils';

export default class ShortTermRentalBreakdown extends Model {
  [Type] = 'short-term-rental-breakdown' as const;

  @attr('string') declare subType: string;
  @attr('string') declare type: string;
  @attr('number') declare value: number;

  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get key() {
    return `${this.type}.${this.subType}`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get name() {
    if (this.type === 'additional_fees') {
      return additionalFeesTranslation(
        this.subType,
        this.hotelAndMarketService,
        this.intl,
      );
    }
    return this.intl.t(`short_term_rental.breakdowns.${this.key}`);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipMessage() {
    return this.intl.t(`short_term_rental.tooltip.breakdowns.${this.key}`);
  }
}
